// extracted by mini-css-extract-plugin
export default {"wrapper":"FilesModal_wrapper__25PRb","content":"FilesModal_content__U1Di4","close_window":"FilesModal_close_window__znfoJ","href":"FilesModal_href__hHcWt"};